/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: apiKeysActions.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Helper functions for API Keys navigation and actions.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';

export const getApiKeyDuplicateUrl = (id: string | number): string =>
  `/admin/admin/app-keys/new?duplicate=${id}`;

export const navigateToApiKeyDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getApiKeyDuplicateUrl(id));
};

